import DropoutService from '../services/DropoutService';
import router from '@/router';

const getDefaultState = () => ({
  dropouts: [],
});
const dropouts = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    dropouts(state, val) {
      state.dropouts = val;
    },
    resetDropouts(state) {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    async GET_STUDENT_DROPOUTS(context) {
      const payload = await DropoutService.fetchDropoutsByStudent({
        studentId: router.currentRoute.params.id,
      });
      const data = payload.data.results;
      context.commit('dropouts', data);
    },
    async RESET_DROPOUTS_STATE(context) {
      await context.commit('resetDropouts');
    },
  },
  getters: {
    getStudentDropouts: state => state.dropouts,
  },
};

export default dropouts;
